import { Conductor, Promotions } from "src/models";
import { ProgramConductorTypes } from "../types";
import { createAction } from "./create.action";

export namespace ProgramsConductorAction {

    export const showLoading = () => createAction(ProgramConductorTypes.SHOW_PROGRAM_CONDUCTOR_LOADING);
    export const hideLoading = () => createAction(ProgramConductorTypes.HIDE_PROGRAM_CONDUCTOR_LOADING);

    export const getData = (count: number, type: number, offset: number, getFeatured: boolean, clear?: boolean, clearBeforeFetch?: boolean) =>
        createAction(ProgramConductorTypes.REQUEST_LOAD_PROGRAM_CONDUCTOR, { count, type, offset, getFeatured, clear, clearBeforeFetch });

    export const setData = (list: Conductor[], promotions: Promotions, clear: boolean, count: number, totalRecords: number) =>
        createAction(ProgramConductorTypes.SET_PROGRAM_CONDUCTOR_DATA, { list, promotions, clear, count, totalRecords });

    export const hidePromotion = (date: string, itemIndex: number, promotionIndex: number) =>
        createAction(ProgramConductorTypes.HIDE_PROMOTION, { date, itemIndex, promotionIndex });

}